import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface ServiceCostsState {
  serviceCosts: any
  currencies: any
  serviceCost: any
  documentCost: any
  documentCosts: any
  editServiceCost: any
  deleteServiceCost: any
  error: any
}

export const useServiceCostsStore = defineStore('serviceCosts', {
  state: (): ServiceCostsState => ({
    serviceCosts: null,
    currencies: null,
    serviceCost: null,
    documentCost: null,
    documentCosts: null,
    editServiceCost: null,
    deleteServiceCost: null,
    error: null,
  }),

  getters: {
    getServiceCosts: (state) => state.serviceCosts,
    getCurrencies: (state) => state.currencies,
    getDeleteServiceCost: (state) => state.deleteServiceCost,
    getEditServiceCost: (state) => state.editServiceCost,
    getServiceCost: (state) => state.serviceCost,
    getDocumentCost: (state) => state.documentCost,
    getDocumentCosts: (state) => state.documentCosts,
    getError: (state) => state.error,
  },

  actions: {
    async fetchServiceCosts() {
      try {
        const response = await api().get('configuration/service-charge/all')
        this.serviceCosts = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async fetchCurrencies() {
      try {
        const response = await api().get('configuration/currency/all')
        this.currencies = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async fetchDocumentCosts() {
      try {
        const response = await api().get('configuration/document-type/all')
        this.documentCosts = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async deleteServiceCost(serviceId: string | number) {
      try {
        const response = await api().get('configuration/service-charge/delete-by-id/?serviceChargeId=' + serviceId)
        this.deleteServiceCost = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async createServiceCost(data: any) {
      try {
        const response = await api().post('configuration/service-charge/create', data)
        this.serviceCost = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async createDocumentCost(data: any) {
      try {
        const response = await api().post('configuration/document-type/create', data)
        this.documentCost = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async editServiceCost(data: any) {
      try {
        const response = await api().post('configuration/service-charge/update', data)
        this.editServiceCost = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async editDocumentCost(data: any) {
      try {
        const response = await api().post('configuration/document-type/update', data)
        this.editServiceCost = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },
  },
})
